export default __webpack_public_path__ + "static/media/icn_check_circle.73fe1446.svg";